module.exports = __webpack_public_path__ + "img/ajiltan_logo.7dddc6c8.svg";